import React, { useEffect, useMemo, useState } from "react";
import { PrinterOutlined } from "@ant-design/icons";
import { Alert, Button, Spin } from "antd";
import { useSearchParams } from "react-router-dom";
import { fetchReportHtml } from "./report-api";
import "./reports.css";

const ALLOWED_PARAMS = ["reportId", "id", "ids", "begPer", "endPer", "part", "idBranch"];

export const sanitizeReportHtml = (html) => {
  const documentNode = new DOMParser().parseFromString(String(html || ""), "text/html");
  documentNode.querySelectorAll("script, iframe, object, embed").forEach((node) => node.remove());
  documentNode.querySelectorAll("*").forEach((element) => {
    Array.from(element.attributes).forEach((attribute) => {
      const name = attribute.name.toLowerCase();
      const value = attribute.value.trim().toLowerCase();
      if (name.startsWith("on")) element.removeAttribute(attribute.name);
      if ((name === "href" || name === "src" || name === "xlink:href") && value.startsWith("javascript:")) {
        element.removeAttribute(attribute.name);
      }
    });
  });
  return `${documentNode.head.innerHTML}${documentNode.body.innerHTML}`;
};

const ReportViewer = () => {
  const [searchParams] = useSearchParams();
  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const params = useMemo(() => {
    const result = {};
    ALLOWED_PARAMS.forEach((key) => {
      const value = searchParams.get(key);
      if (value !== null && value !== "") result[key] = value;
    });
    return result;
  }, [searchParams]);

  useEffect(() => {
    const controller = new AbortController();
    if (!params.reportId) {
      setError("Не указан идентификатор отчёта");
      setLoading(false);
      return () => controller.abort();
    }
    setLoading(true);
    setError("");
    fetchReportHtml(params, controller.signal)
      .then((content) => setHtml(sanitizeReportHtml(content)))
      .catch((e) => {
        if (e.name !== "AbortError") setError(e.message || "Не удалось сформировать отчёт");
      })
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, [params]);

  if (loading) {
    return (
      <div className="report-viewer__state">
        <Spin size="large" tip="Формирование отчёта..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="report-viewer__state">
        <Alert type="error" showIcon message="Ошибка формирования отчёта" description={error} />
      </div>
    );
  }

  return (
    <main className="report-viewer">
      <div className="report-viewer__toolbar">
        <Button type="primary" icon={<PrinterOutlined />} onClick={() => window.print()}>
          Печать
        </Button>
      </div>
      <div
        className="report-viewer__content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </main>
  );
};

export default ReportViewer;
